import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=641e46c1&scoped=true"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=641e46c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e46c1",
  null
  
)

export default component.exports